export default __webpack_public_path__ + "static/media/loading.dcd6c719.gif";